// extracted by mini-css-extract-plugin
export var beian = "index-module--beian--6G2vg";
export var contactUs = "index-module--contactUs--uwO6u";
export var contact_and_link = "index-module--contact_and_link--mbX+J";
export var empty = "index-module--empty--w0Iy8";
export var footer = "index-module--footer--uojx8";
export var footerBottom = "index-module--footerBottom--CzqSL";
export var footerTop = "index-module--footerTop--1CP1E";
export var friendly_link = "index-module--friendly_link--FFtoQ";
export var friendly_link_content = "index-module--friendly_link_content--aC9ry";
export var google = "index-module--google--AmQzW";
export var linkedin = "index-module--linkedin--+Wq5b";
export var platform = "index-module--platform--yVqRb";
export var reddit = "index-module--reddit--WO-SN";
export var region = "index-module--region--J9hgF";
export var regionBig = "index-module--regionBig--CQjde";
export var regionContent = "index-module--regionContent--tzSQe";
export var stackoverflow = "index-module--stackoverflow--e-ZFn";
export var subTitle = "index-module--subTitle---IHrj";
export var tooltipInner = "index-module--tooltipInner--lCUCH";
export var twitter = "index-module--twitter--Ou83N";
export var wechatContent = "index-module--wechatContent--MeClf";
export var wechatTooltip = "index-module--wechatTooltip--cRklD";